
import { useAct } from 'FlowTaker/store'
import { Field, ErrorMessage } from 'formik'
import SafeRenderHtml from 'CampaignVolunteer/components/SafeRenderHtml'
import { questionTypeComponents } from 'FlowTaker/lib/formHelpers'
import useQuestionTranslate from 'FlowBuilder/hooks/useQuestionTranslate'

export default function Question({ question }) {
  const act = useAct()
  const QuestionType = questionTypeComponents[question.questionType] || questionTypeComponents.unknown

  if (!QuestionType) {
    throw new Error(`No question type component found for ${question.questionType}`)
  }

  const answers = useSel(s => _.values(s.answers.entities).filter(a => a.questionId === question.id))
  const { fallback: { name: questionTitle } } = useQuestionTranslate({ questionOverride: question })
  let label = String(questionTitle ?? question.question).replaceAll("\n", "<br />")
  if (question.questionType !== 'instruction' && question.settings?.required) {
    label = `${label} *`
  }
  const fieldName = question.id

  function updateFlowResponse(value) {
    if (question.questionType === 'multiple_select') {
      act.taker.setResponse({ questionId: question.id, answerIds: value })
    } else if (question.questionType === 'multiple_choice') {
      act.taker.setResponse({ questionId: question.id, answerId: value })
    } else {
      act.taker.setResponse({ questionId: question.id, answerText: value })
    }
  }

  return (
    <div className={`mvmt-question-${question.digitOrder} mvmt-question-${_.kebabCase(question.question)} field question-type-${question.questionType}`}>
      {question.questionType === 'instruction' && <SafeRenderHtml html={label} />}
      {!['instruction', 'checkbox'].includes(question.questionType) && <label className="question-question">{label}</label>}
      {!['instruction', 'checkbox'].includes(question.questionType) && question.instructions &&
        <p className="question-instructions"><SafeRenderHtml html={question.instructions} /></p>
      }
      <Field name={fieldName}>
        {({ field, form }) => {
          const setResponse = (value) => {
            form.setFieldValue(field.name, value)
            updateFlowResponse(value)
          }
          const response = field.value

          return (
            <QuestionType
              name={field.name}
              label={label}
              answers={answers}
              response={response}
              setResponse={setResponse}
              settings={question.settings}
              placeholder={questionTitle || question.question}
              disabled={form.isSubmitting}
              formikName={fieldName}
              question={question}
            />
          );
        }}
      </Field>
      <ErrorMessage
        name={fieldName}
        component={({ children }) => {
          return <p className="smaller error no-margin-bottom">{children}</p>
        }}
      />
    </div>
  )
}
